import type { ComponentsOverrides, ComponentsVariants, ComponentsProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { Card_BaseFragmentFragment } from '@ias/graphql-sdk';

export enum CardVariants {
  // Icon variants
  icon = 'icon',
  iconLeft = 'iconLeft',
  iconCenter = 'iconCenter',
  iconPadding = 'iconPadding',

  // Logo variant
  logo = 'logo',

  // Block variant
  block = 'block',

  // Other variants
  media = 'media',
  testimonial = 'testimonial',
  iconStats = 'iconStats',
  iconListing = 'iconListing',
  linksList = 'links list',
  default = 'default'
}

export enum CardAspectRatios {
  default = 'default',
  square = 'square',
  horizontal = 'horizontal',
  vertical = 'vertical'
}

export interface CardProps extends Omit<Card_BaseFragmentFragment, 'variant' | 'aspectRatio'> {
  loading?: boolean;
  variant?: CardVariants;
  ownerState?: any;
  aspectRatio?: CardAspectRatios;
  gridLayout?: any;
  layoutConfig?: any;
  backgroundColor?: string;
  className?: string;
  overline?: string;
  sx?: any;
  elevation?: number;
}

export interface CardOwnerState extends CardProps {}

export interface CardClasses {
  root: string;
  cardWrap: string;
  link: string;
  media: string;
  mediaFlip: string;
  mediaContainer: string;
  actionsWrap: string;
  action: string;
  contentWrap: string;
  overline: string;
  title: string;
  subtitle: string;
  body: string;
  bodyWrap: string;
  quote: string;
  attribution: string;
  statValue: string;
  statLabel: string;
}

export declare type CardClassKey = keyof CardClasses;

declare module '@mui/material' {
  export interface ComponentNameToClassKey {
    Card: CardClassKey;
  }

  export interface ComponentsPropsList {
    Card: CardProps;
  }
}

declare module '@mui/material' {
  interface Components {
    Card?: {
      defaultProps?: ComponentsProps['Card'];
      styleOverrides?: ComponentsOverrides<Theme>['Card'];
      variants?: ComponentsVariants['Card'];
    };
  }
}
